import React from "react";
import { Card, Container, Row, Col } from "react-bootstrap";
import "./LessonsReservationPage.css";

export interface Subject {
  name: string;
  img?: string;
}

interface SubjectsSelectionProps {
  subjects: Subject[];
  onSubjectSelect: (subjectName: string) => void;
}

const SubjectsSelection: React.FC<SubjectsSelectionProps> = ({
  subjects,
  onSubjectSelect,
}) => {
  return (
    <Container>
      <h2 className="mb-4 text-center">Odaberite predmet</h2>
      <div className="d-flex flex-wrap justify-content-center">
        {subjects.map((subject) => (
          <Card
            key={subject.name}
            className="subject-card shadow-sm mx-2 my-2"
            onClick={() => onSubjectSelect(subject.name)}
            style={{ cursor: "pointer" }}
          >
            <Card.Img
              variant="top"
              src={subject.img}
              alt={subject.name}
              className="p-2"
              style={{ objectFit: "contain", height: "70%" }}
            />
            <Card.Body className="text-center p-2">
              <Card.Title className="fs-6">{subject.name}</Card.Title>
            </Card.Body>
          </Card>
        ))}
      </div>
    </Container>
  );
};

export default SubjectsSelection;
